module.exports = __webpack_public_path__ + "img/goal-five-en.9da33cf4.png";